import NewsListShow from '../newsList/src/index.vue'

export default NewsListShow